import { History } from 'history';
import { RateQuote } from '../../../modules/rate-quote/types';
import { LockedRateQuoteFailedStatus, LockedRateQuoteSuccessStatus } from '../state';

export const FetchRateQuoteActionType = 'RATE_QUOTE__FETCH_REQUEST_ACTION' as const;
export const fetchRateQuoteRequest = (rateQuoteId: string, fetchAllRates: boolean) => ({
  type: FetchRateQuoteActionType,
  payload: { rateQuoteId, fetchAllRates }
});
export type FetchRateQuoteRequestAction = ReturnType<typeof fetchRateQuoteRequest>;

export const FetchRateQuoteSuccessActionType = 'RATE_QUOTE__FETCH_RESPONSE_SUCCESS_ACTION' as const;
export const fetchRateQuoteSuccess = (payload: RateQuote) => ({
  type: FetchRateQuoteSuccessActionType,
  payload
});
export type FetchRateQuoteSuccessAction = ReturnType<typeof fetchRateQuoteSuccess>;

export const FetchRateQuoteFailureActionType = 'RATE_QUOTE__FETCH_RESPONSE_FAILURE_ACTION' as const;
export const fetchRateQuoteError = (message: string, code: number) => ({
  type: FetchRateQuoteFailureActionType,
  payload: {
    message,
    code
  }
});
export type FetchRateQuoteFailureAction = ReturnType<typeof fetchRateQuoteError>;

export const SaveMerchandisingActionType = 'RATE_QUOTE__SAVE_MERCHANDISING_ACTION' as const;
/**
 * Trigger a save either immediately or after a timeout of no save
 *  actions being called for a set period.
 *
 * @param saveImmediately set to false to trigger the timeout
 */
export const saveMerchandising = (saveImmediately: boolean) => ({
  type: SaveMerchandisingActionType,
  payload: saveImmediately
});
export type SaveMerchandisingAction = ReturnType<typeof saveMerchandising>;

export const SaveMerchandisingSuccessActionType = 'RATE_QUOTE__SAVE_MERCHANDISING_SUCCESS' as const;
export const saveMerchandisingSuccess = (payload: RateQuote) => ({
  type: SaveMerchandisingSuccessActionType,
  payload
});
export type SaveMerchandisingSuccessAction = ReturnType<typeof saveMerchandisingSuccess>;

export const SaveMerchandisingErrorActionType = 'RATE_QUOTE__SAVE_MERCHANDISING_ERROR' as const;
export const saveMerchandisingError = (payload: string) => ({
  type: SaveMerchandisingErrorActionType,
  payload
});
export type SaveMerchandisingErrorAction = ReturnType<typeof saveMerchandisingError>;

export const FetchLockedOfferBySourceActionType = 'RATE_QUOTE_FETCH_LOCKED_OFFER_BY_SOURCE' as const;
export const fetchLockedOfferBySource = (payload: { sourceId: string; history: History<any> }) => ({
  type: FetchLockedOfferBySourceActionType,
  payload
});
export type FetchLockedOfferBySourceAction = ReturnType<typeof fetchLockedOfferBySource>;

export const FetchLockedOfferBySourceSuccessActionType = 'RATE_QUOTE_FETCH_LOCKED_OFFER_BY_SOURCE_SUCCESS' as const;
export const fetchLockedOfferBySourceSuccess = (payload: LockedRateQuoteSuccessStatus) => ({
  type: FetchLockedOfferBySourceSuccessActionType,
  payload
});
export type FetchLockedOfferBySourceSuccessAction = ReturnType<
  typeof fetchLockedOfferBySourceSuccess
>;

export const FetchLockedOfferBySourceFailureActionType = 'RATE_QUOTE_FETCH_LOCKED_OFFER_BY_SOURCE_FAILURE' as const;
export const fetchLockedOfferBySourceFailure = (payload: LockedRateQuoteFailedStatus) => ({
  type: FetchLockedOfferBySourceFailureActionType,
  payload
});
export type FetchLockedOfferBySourceFailureAction = ReturnType<
  typeof fetchLockedOfferBySourceFailure
>;
